/*  ========================================================================
    # Hero Image Slider
    ========================================================================  */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import tailwindConfig from '../../../../tailwind.config';

// Components
import LazyImage from '@/react/components/LazyImage';
import LazySource from '@/react/components/LazySource';

const HeroImageSlider = ({ images }) => {
  const durationTime = 4000;
  const [activeSlide, setActiveSlide] = useState(0);

  const getDataOffset = index => {
    if (index === activeSlide) {
      return 0;
    } else if (activeSlide - 1 === index || (activeSlide === 0 && index === images.length - 1)) {
      return -1;
    } else {
      return 1;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => {
        if (prev < images.length - 1) {
          return prev + 1;
        } else {
          return 0;
        }
      });
    }, durationTime);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='s-hero__slider'>
      <div
        className='s-hero__slider-wrapper'
        style={{ '--active-slide': activeSlide, '--slide-duration-time': durationTime + 'ms' }}
      >
        {images.map((image, index) => (
          <div className='s-hero__slider-item' data-offset={getDataOffset(index)} key={index}>
            <LazyImage
              defaultUrl={image.sizes.medium_large}
              alt={image.alt}
              placeholderUrl={image.sizes.placeholder}
              preload={index === 0}
              customRootMargin='50px'
            >
              <LazySource
                srcSet={`${image.sizes.large} 1x, ${image.sizes['1536x1536']} 2x`}
                mediaMin={tailwindConfig.theme.screens.md}
              />
              <LazySource
                srcSet={`${image.sizes.medium} 1x, ${image.sizes.medium_large} 2x`}
                mediaMin={tailwindConfig.theme.screens.sm}
              />
            </LazyImage>
          </div>
        ))}
      </div>
    </div>
  );
};

HeroImageSlider.propTypes = {
  images: PropTypes.array
};

export default HeroImageSlider;
